import * as IoC from 'inversify';
import { TrackingService } from './tracking-service';
import { TrackingService2, TrackingService2Symbol } from './tracking-api';
import { EventStreamListenerSymbol } from '@/app/event-stream';
import { tincanModule } from './xapi';
import { scorm2004Module } from './scorm';

const trackingModule = new IoC.ContainerModule((bind) => {

  bind(TrackingService).toSelf().inSingletonScope();
  bind<TrackingService2>(TrackingService2Symbol).toDynamicValue((c) => c.container.get(TrackingService));
  bind(EventStreamListenerSymbol).toDynamicValue((c) => c.container.get(TrackingService));
});

export const trackingModules = [
  trackingModule,
  tincanModule,
  scorm2004Module
];
